import { filterInstitutionRows } from "../../../shared/sessionCache.js";
import { DefaultAvatar } from "../../../components/ProfileSummary/index.jsx";
import React, { useState, useRef, useEffect } from "react";
import api from "../../../services/api";
import { fmtDate, fmtNum, tempoRel, todayISO } from "../../../shared/utils";
import { sourceImage } from "../../../utils/source-image";
import { Modal } from "../../../components/Modal";
import CadastroEstudo from "./Create";
export default function Feed(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  let checkpoints = props.checkpoints;
  let students = props.students;
  let houses = props.houses;
  let teachers = props.teachers;
  let activities = props.activities;
  let currentStudent =
    (props.conteudos, props.setConteudosNavigationTarget, props.currentStudent);
  let adminLogged = props.adminLogged;
  let verPerfil = props.verPerfil;
  let setCheckpoints = props.setCheckpoints;
  let showFlash = props.showFlash;
  const [filtroCasa, setFiltroCasa] = useState(0);
  const [buscaNome, setBuscaNome] = useState("");
  const [buscaAberta, setBuscaAberta] = useState(false);
  const [alunosFiltradosIds, setAlunosFiltradosIds] = useState(null);
  const [sugestoesBusca, setSugestoesBusca] = useState([]);
  const [isLoadingSugestoes, setIsLoadingSugestoes] = useState(false);
  const [isSearchingAluno, setIsSearchingAluno] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [questionandoId, setQuestionandoId] = useState(null);
  const [justificativa, setJustificativa] = useState("");
  const [visibleCount, setVisibleCount] = useState(10);
  const [imagemExpandida, setImagemExpandida] = useState(null);
  const [showCadastroModal, setShowCadastroModal] = useState(false);
  const checkpointsSeededRef = useRef(false);
  useEffect(() => {
    if (checkpoints.length && !checkpointsSeededRef.current) {
      checkpointsSeededRef.current = true;
      setCheckpoints(checkpoints);
    }
  }, [checkpoints, setCheckpoints]);
  useEffect(() => {
    if (!imagemExpandida) return;
    const onKeyDown = (event) => {
      if ("Escape" === event.key) {
        setImagemExpandida(null);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [imagemExpandida]);
  useEffect(() => {
    if (!buscaAberta || buscaNome.trim().length < 1) {
      setSugestoesBusca([]);
      setIsLoadingSugestoes(false);
      return;
    }
    let ativo = true;
    const timeoutId = setTimeout(async () => {
      setIsLoadingSugestoes(true);
      try {
        const responseData = await institutionApi.get("/students", {
          params: {
            q: buscaNome.trim(),
            page: 1,
            limit: 6,
          },
        });
        const resultados = Array.isArray(responseData?.data?.data)
          ? responseData.data.data.filter((student) => student?.ativo)
          : [];
        if (!ativo) return;
        setSugestoesBusca(resultados);
      } catch (error) {
        if (!ativo) return;
        setSugestoesBusca([]);
      } finally {
        if (ativo) {
          setIsLoadingSugestoes(false);
        }
      }
    }, 220);
    return () => {
      ativo = false;
      clearTimeout(timeoutId);
    };
  }, [buscaAberta, buscaNome]);
  const podeExcluir = (checkpoint) =>
    adminLogged ||
    (currentStudent && currentStudent.id === checkpoint.aluno_id);
  const podeQuestionar = (checkpointAtual2) => {
    if (!currentStudent || checkpointAtual2.aluno_id === currentStudent.id)
      return false;
    if (checkpointAtual2.questionado_por) return false;
    const hoje = todayISO();
    return !checkpoints.some(
      (checkpoint) =>
        checkpoint.questionado_por === currentStudent.id &&
        checkpoint.data_estudo === hoje,
    );
  };
  const checkpointsFiltrados = filterInstitutionRows(
    checkpoints,
    currentStudent,
  ).filter((item) => {
    if (Number(item.hidden_from_feed)) return false;
    const aluno = students.find((student) => student.id === item.aluno_id);
    return (
      !(filtroCasa > 0 && Number(aluno?.casa_id || 0) !== filtroCasa) &&
      (!Array.isArray(alunosFiltradosIds) ||
        alunosFiltradosIds.includes(Number(item.aluno_id)))
    );
  });
  const visibleCheckpoints = checkpointsFiltrados.slice(0, visibleCount);
  const hasMoreCheckpoints = visibleCount < checkpointsFiltrados.length;
  return (
    <div
      className={"cn"}
      style={{
        paddingTop: 10,
      }}
    >
      {currentStudent && (
        <button
          className={"btn bb"}
          style={{
            marginBottom: 12,
          }}
          onClick={() => setShowCadastroModal(true)}
        >
          {"+ Adicionar Feed"}
        </button>
      )}
      <div
        style={{
          display: "flex",
          gap: 8,
          marginBottom: 12,
          flexWrap: "wrap",
          background: "rgba(255,255,255,0.97)",
          borderRadius: 12,
          padding: "10px 12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
        }}
      >
        <select
          className={"sel"}
          style={{
            flex: "1 1 120px",
            minWidth: 0,
          }}
          value={filtroCasa}
          onChange={(event) => setFiltroCasa(Number(event.target.value))}
        >
          <option value={0}>{"Todas as instituições"}</option>
          {houses.map((house) => (
            <option value={house.id} key={house.id}>
              {house.nome}
            </option>
          ))}
        </select>
        <div
          style={{
            flex: "2 1 160px",
            minWidth: 0,
            position: "relative",
          }}
        >
          <svg
            width={"15"}
            height={"15"}
            viewBox={"0 0 24 24"}
            fill={"none"}
            stroke={"#B8C5CC"}
            strokeWidth={"2"}
            strokeLinecap={"round"}
            style={{
              position: "absolute",
              left: 11,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "none",
              zIndex: 1,
            }}
          >
            <circle cx={"11"} cy={"11"} r={"8"} />
            <line x1={"21"} y1={"21"} x2={"16.65"} y2={"16.65"} />
          </svg>
          <input
            className={"inp"}
            style={{
              paddingLeft: 32,
            }}
            placeholder={"Buscar aluno pelo nome..."}
            value={buscaNome}
            onChange={(event) => {
              const nextValue = event.target.value;
              setBuscaNome(nextValue);
              if (!nextValue.trim()) {
                setAlunosFiltradosIds(null);
                setSugestoesBusca([]);
              }
            }}
            onFocus={() => setBuscaAberta(true)}
            onBlur={() => setTimeout(() => setBuscaAberta(false), 180)}
            autoComplete={"off"}
          />
          {buscaAberta &&
            buscaNome.length >= 1 &&
            (() => {
              const sugestoes = sugestoesBusca;
              const totalResultados = sugestoesBusca.length;
              return sugestoes.length || isLoadingSugestoes ? (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    background: "#FFF",
                    border: "1.5px solid #4FB3A9",
                    borderTop: "none",
                    borderRadius: "0 0 10px 10px",
                    zIndex: 50,
                    boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                    overflow: "hidden",
                  }}
                >
                  {isLoadingSugestoes && (
                    <div
                      style={{
                        padding: "10px 12px",
                        fontSize: 11,
                        color: "#6B8590",
                        textAlign: "center",
                      }}
                    >
                      {"Buscando alunos..."}
                    </div>
                  )}
                  {sugestoes.map((sugestoe) => (
                    <div
                      onMouseDown={() => {
                        setBuscaNome(sugestoe.nome);
                        setBuscaAberta(false);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 9,
                        padding: "9px 12px",
                        cursor: "pointer",
                        borderBottom: "1px solid #F4F8F9",
                        transition: "background .1s",
                      }}
                      onMouseOver={(event) => {
                        event.currentTarget.style.background = "#F4F8F9";
                      }}
                      onMouseOut={(event) => {
                        event.currentTarget.style.background = "transparent";
                      }}
                      key={sugestoe.id}
                    >
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          color: "#FFF",
                          display: "grid",
                          placeItems: "center",
                          fontSize: 11,
                          fontWeight: 700,
                          flexShrink: 0,
                          background: sugestoe.foto ? "transparent" : "#1F4754",
                          backgroundImage: sugestoe.foto
                            ? "url(".concat(sourceImage(sugestoe.foto), ")")
                            : "none",
                          backgroundSize: "cover",
                        }}
                      >
                        {!sugestoe.foto && DefaultAvatar()}
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#1F4754",
                            lineHeight: 1.2,
                          }}
                        >
                          {sugestoe.nome}
                        </div>
                        <div
                          style={{
                            fontSize: 10,
                            color: "#6B8590",
                            marginTop: 2,
                          }}
                        >
                          {sugestoe.escola || ""}
                          {sugestoe.ano ? " · ".concat(sugestoe.ano) : ""}
                        </div>
                      </div>
                    </div>
                  ))}
                  {!isLoadingSugestoes && !sugestoes.length && (
                    <div
                      style={{
                        padding: "10px 12px",
                        fontSize: 11,
                        color: "#6B8590",
                        textAlign: "center",
                      }}
                    >
                      {"Nenhum aluno encontrado."}
                    </div>
                  )}
                  {totalResultados >= 6 && (
                    <div
                      style={{
                        padding: "7px 12px",
                        fontSize: 11,
                        color: "#6B8590",
                        textAlign: "center",
                        borderTop: "1px solid #F0F4F6",
                      }}
                    >
                      {"Continue digitando para refinar a busca"}
                    </div>
                  )}
                </div>
              ) : null;
            })()}
        </div>
        <button
          className={"btn"}
          onClick={async () => {
            const termo = buscaNome.trim();
            if (!termo) {
              institutionContext?.onSearch?.("");
              setAlunosFiltradosIds(null);
              setVisibleCount(10);
              return;
            }
            institutionContext?.onSearch?.(termo);
            setIsSearchingAluno(true);
            try {
              const responseData2 = await institutionApi.get("/students", {
                params: {
                  q: termo,
                  page: 1,
                  limit: 50,
                },
              });
              const resultados = Array.isArray(responseData2?.data?.data)
                ? responseData2.data.data
                : [];
              const ids = resultados
                .filter((student) => student?.ativo)
                .map((student) => Number(student.id))
                .filter(Number.isFinite);
              setAlunosFiltradosIds(ids);
              setSugestoesBusca(
                resultados.filter((student) => student?.ativo).slice(0, 6),
              );
              setVisibleCount(10);
              if (!ids.length) {
                showFlash("Nenhum aluno encontrado para essa busca.", "wa");
              }
            } catch (error) {
              showFlash(
                error?.response?.data?.message ||
                  "Nao foi possivel pesquisar o aluno agora.",
                "er",
              );
            } finally {
              setIsSearchingAluno(false);
              setBuscaAberta(false);
            }
          }}
          disabled={isSearchingAluno}
          style={{
            flexShrink: 0,
            minWidth: 112,
          }}
        >
          {isSearchingAluno ? "Buscando..." : "Pesquisar"}
        </button>
        {(filtroCasa > 0 || buscaNome) && (
          <button
            className={"btn bg bs"}
            onClick={() => {
              institutionContext?.onSearch?.("");
              setFiltroCasa(0);
              setBuscaNome("");
              setAlunosFiltradosIds(null);
              setSugestoesBusca([]);
              setVisibleCount(10);
            }}
          >
            {"Limpar"}
          </button>
        )}
      </div>
      {0 === checkpointsFiltrados.length ? (
        <div className={"es"}>
          <h3>{"Nenhum checkpoint encontrado"}</h3>
          <p
            style={{
              marginTop: 6,
            }}
          >
            {filtroCasa > 0 || Array.isArray(alunosFiltradosIds)
              ? "Nenhum resultado para os filtros aplicados."
              : "Quando os alunos cadastrarem, aparece aqui."}
          </p>
          {currentStudent && (
            <p
              style={{
                marginTop: 14,
              }}
            >
              <button
                className={"btn"}
                onClick={() => setShowCadastroModal(true)}
              >
                {"+ Adicionar Feed"}
              </button>
            </p>
          )}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 14,
          }}
        >
          {visibleCheckpoints.map((visibleCheckpoint) => {
            const aluno = students.find(
              (student) => student.id === visibleCheckpoint.aluno_id,
            );
            const casa =
              aluno && houses.find((house) => house.id === aluno.casa_id);
            const prof =
              aluno &&
              teachers.find((teacher) => teacher.id === aluno.professor_id);
            const invalido = "invalido" === visibleCheckpoint.status_questao;
            return (
              <article
                className={"card"}
                style={
                  invalido
                    ? {
                        opacity: 0.55,
                      }
                    : {}
                }
                key={visibleCheckpoint.id}
              >
                <div className={"ch"}>
                  <div
                    className={"ca"}
                    style={
                      null !== aluno && undefined !== aluno && aluno.foto
                        ? {
                            backgroundImage: "url(".concat(
                              sourceImage(aluno.foto),
                              ")",
                            ),
                          }
                        : {}
                    }
                    onClick={() => verPerfil(aluno.id)}
                  >
                    {!(null !== aluno && undefined !== aluno && aluno.foto) &&
                      DefaultAvatar()}
                  </div>
                  <div className={"cw"}>
                    <div className={"cn2"} onClick={() => verPerfil(aluno.id)}>
                      {aluno?.nome}
                    </div>
                    <div className={"cm"}>
                      {tempoRel(visibleCheckpoint.criado_em)}
                      {" - "}
                      {fmtDate(visibleCheckpoint.data_estudo)}
                      {prof && " - prof. ".concat(prof.nome)}
                      {aluno?.escola && " - ".concat(aluno?.escola)}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: 4,
                    }}
                  >
                    {casa && (
                      <div
                        className={"ct2"}
                        style={{
                          background: casa.cor,
                        }}
                      >
                        {casa.nome}
                      </div>
                    )}
                    {"pendente" === visibleCheckpoint.status_questao && (
                      <span
                        style={{
                          fontSize: 9,
                          fontWeight: 700,
                          padding: "2px 7px",
                          borderRadius: 999,
                          background: "#FFF3CD",
                          color: "#856404",
                        }}
                      >
                        {"Em análise"}
                      </span>
                    )}
                    {"invalido" === visibleCheckpoint.status_questao && (
                      <span
                        style={{
                          fontSize: 9,
                          fontWeight: 700,
                          padding: "2px 7px",
                          borderRadius: 999,
                          background: "#FFE5E0",
                          color: "#B83A2E",
                        }}
                      >
                        {"Invalidado"}
                      </span>
                    )}
                    {podeExcluir(visibleCheckpoint) &&
                      (confirmDelete === visibleCheckpoint.id ? (
                        <div
                          style={{
                            display: "flex",
                            gap: 4,
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              fontSize: 9,
                              color: "#B83A2E",
                              fontWeight: 700,
                            }}
                          >
                            {institutionContext
                              ? "Retirar do Feed?"
                              : "Excluir?"}
                          </span>
                          <button
                            onClick={() =>
                              (async (cpId) => {
                                try {
                                  await institutionApi.delete(
                                    "/checkpoints?id=".concat(cpId),
                                  );
                                  setCheckpoints((prev) =>
                                    prev.filter(
                                      (prevId) =>
                                        Number(prevId.id) !== Number(cpId),
                                    ),
                                  );
                                  setConfirmDelete(null);
                                  showFlash(
                                    institutionContext
                                      ? "Postagem retirada do Feed."
                                      : "Postagem excluída.",
                                    "in",
                                  );
                                } catch (err) {
                                  showFlash(
                                    err.response?.data?.message ||
                                      "Nao foi possivel excluir a postagem.",
                                    "er",
                                  );
                                }
                              })(visibleCheckpoint.id)
                            }
                            style={{
                              background: "#D9534F",
                              border: "none",
                              color: "#FFF",
                              borderRadius: 5,
                              padding: "2px 7px",
                              fontSize: 9,
                              fontWeight: 700,
                              cursor: "pointer",
                            }}
                          >
                            {"Sim"}
                          </button>
                          <button
                            onClick={() => setConfirmDelete(null)}
                            style={{
                              background: "#E0E8EB",
                              border: "none",
                              color: "#6B8590",
                              borderRadius: 5,
                              padding: "2px 7px",
                              fontSize: 9,
                              fontWeight: 700,
                              cursor: "pointer",
                            }}
                          >
                            {"Não"}
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() => setConfirmDelete(visibleCheckpoint.id)}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#D9534F",
                            cursor: "pointer",
                            padding: "2px 4px",
                            fontSize: 11,
                            lineHeight: 1,
                          }}
                          title={
                            institutionContext
                              ? "Retirar postagem"
                              : "Excluir postagem"
                          }
                        >
                          <svg
                            width={"14"}
                            height={"14"}
                            viewBox={"0 0 24 24"}
                            fill={"none"}
                            stroke={"currentColor"}
                            strokeWidth={"2"}
                            strokeLinecap={"round"}
                          >
                            <polyline points={"3 6 5 6 21 6"} />
                            <path
                              d={
                                "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
                              }
                            />
                            <path d={"M10 11v6"} />
                            <path d={"M14 11v6"} />
                            <path d={"M9 6V4h6v2"} />
                          </svg>
                        </button>
                      ))}
                  </div>
                </div>
                <div className={"cb"}>
                  {visibleCheckpoint.foto && (
                    <div
                      style={{
                        margin: "-12px -14px 12px",
                        overflow: "hidden",
                        borderRadius: "0",
                      }}
                    >
                      <img
                        src={sourceImage(visibleCheckpoint.foto)}
                        onClick={() =>
                          setImagemExpandida(
                            sourceImage(visibleCheckpoint.foto),
                          )
                        }
                        alt={"foto do estudo"}
                        style={{
                          position: "relative",
                          width: "100%",
                          maxHeight: 280,
                          objectFit: "cover",
                          cursor: "zoom-in",
                          display: "block",
                        }}
                      />
                    </div>
                  )}
                  {visibleCheckpoint.observacao && (
                    <div
                      className={"obs"}
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      {visibleCheckpoint.observacao}
                    </div>
                  )}
                  <div className={"al"}>
                    {visibleCheckpoint.itens.map((iten, idx) => {
                      const tipo = activities.find(
                        (activity) => activity.id === iten.tipo_id,
                      );
                      if (!tipo) return null;
                      const quantidade = iten.quantidade;
                      const quantidadeFmt = fmtNum(quantidade, 2);
                      return (
                        <div
                          className={"ai"}
                          style={{
                            borderLeftColor: tipo.cor,
                          }}
                          key={idx}
                        >
                          <div>
                            <div className={"ail"}>{tipo.nome}</div>
                            <div className={"aiq"}>
                              {quantidadeFmt} {tipo.unidade}
                              {quantidade > 1 ? "s" : ""}
                            </div>
                          </div>
                          <div className={"aip"}>
                            <div className={"rank"}>
                              {"+"}
                              {fmtNum(iten.pts_rank || 0)}
                              <small>{"Pontos"}</small>
                            </div>
                            <div className={"tok"}>
                              {"+"}
                              {fmtNum(iten.pts_token || 0)}
                              <small>{"Tokens"}</small>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {podeQuestionar(visibleCheckpoint) &&
                    (questionandoId === visibleCheckpoint.id ? (
                      <div
                        style={{
                          marginTop: 9,
                          background: "#FFF8E0",
                          borderRadius: 9,
                          padding: "10px 11px",
                          border: "1px solid #F59E0B",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#856404",
                            marginBottom: 6,
                          }}
                        >
                          {"Justifique o questionamento:"}
                        </div>
                        <textarea
                          className={"tea"}
                          style={{
                            minHeight: 60,
                            fontSize: 12,
                            marginBottom: 7,
                            borderColor: "#F59E0B",
                          }}
                          value={justificativa}
                          onChange={(event) =>
                            setJustificativa(event.target.value)
                          }
                          placeholder={
                            "Ex: Quantidade parece exagerada para o tempo disponível..."
                          }
                        />
                        <div
                          style={{
                            display: "flex",
                            gap: 6,
                          }}
                        >
                          <button
                            className={"btn bor bs"}
                            style={{
                              flex: 1,
                              fontSize: 11,
                            }}
                            onClick={() =>
                              (async (item) => {
                                const justificativaLimpa = justificativa.trim();
                                if (justificativaLimpa && currentStudent)
                                  try {
                                    const responseData2 =
                                      await institutionApi.post(
                                        "/checkpoints/questionar",
                                        {
                                          checkpoint_id: item.id,
                                          questionado_por: currentStudent.id,
                                          justificativa_questao:
                                            justificativaLimpa,
                                        },
                                      );
                                    const atualizado =
                                      responseData2.data?.data ??
                                      responseData2.data;
                                    setCheckpoints((prev) =>
                                      prev.map((prevId) =>
                                        prevId.id === item.id
                                          ? atualizado
                                          : prevId,
                                      ),
                                    );
                                    showFlash(
                                      "Denúncia enviada! O professor irá analisar.",
                                      "wa",
                                    );
                                    setQuestionandoId(null);
                                    setJustificativa("");
                                  } catch (err) {
                                    showFlash(
                                      err.response?.data?.message ||
                                        "Nao foi possivel enviar a denuncia agora.",
                                      "er",
                                    );
                                  }
                              })(visibleCheckpoint)
                            }
                            disabled={!justificativa.trim()}
                          >
                            {"Enviar"}
                          </button>
                          <button
                            className={"btn bg bs"}
                            style={{
                              flex: 1,
                              fontSize: 11,
                            }}
                            onClick={() => {
                              setQuestionandoId(null);
                              setJustificativa("");
                            }}
                          >
                            {"Cancelar"}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <button
                        className={"btn bg bs"}
                        style={{
                          marginTop: 9,
                          fontSize: 11,
                          width: "100%",
                        }}
                        onClick={() => setQuestionandoId(visibleCheckpoint.id)}
                      >
                        {"Questionar este checkpoint"}
                      </button>
                    ))}
                </div>
                <div className={"ck"}>
                  <span
                    style={{
                      fontSize: 9,
                      letterSpacing: ".2em",
                      textTransform: "uppercase",
                      color: "#6B8590",
                      fontWeight: 600,
                    }}
                  >
                    {"Total"}
                  </span>
                  <div
                    style={{
                      textAlign: "right",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontWeight: 800,
                        color: "#FF8C42",
                      }}
                    >
                      {fmtNum(visibleCheckpoint.pontos_rank || 0)}{" "}
                      <small
                        style={{
                          fontSize: 9,
                          color: "#6B8590",
                          fontWeight: 600,
                          textTransform: "uppercase",
                        }}
                      >
                        {"Pontos"}
                      </small>
                    </span>
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 700,
                        color: "#4FB3A9",
                        marginLeft: 10,
                      }}
                    >
                      {fmtNum(visibleCheckpoint.tokens || 0)}{" "}
                      <small
                        style={{
                          fontSize: 9,
                          color: "#6B8590",
                          fontWeight: 600,
                          textTransform: "uppercase",
                        }}
                      >
                        {"Tokens"}
                      </small>
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
          {hasMoreCheckpoints && (
            <div
              style={{
                padding: "20px",
                textAlign: "center",
              }}
            >
              <button
                onClick={async () => {
                  setVisibleCount((prev) => prev + 20);
                }}
                style={{
                  padding: "12px 24px",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#fff",
                  backgroundColor: "#4FB3A9",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  transition: "all 0.3s",
                }}
              >
                {"Carregar Mais"}
              </button>
            </div>
          )}
        </div>
      )}
      {imagemExpandida && (
        <div
          onClick={() => setImagemExpandida(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(5, 16, 22, 0.88)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }}
        >
          <button
            onClick={() => setImagemExpandida(null)}
            style={{
              position: "absolute",
              top: 14,
              right: 14,
              width: 34,
              height: 34,
              border: "none",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.18)",
              color: "#FFF",
              cursor: "pointer",
              fontSize: 19,
              lineHeight: 1,
            }}
            aria-label={"Fechar imagem"}
            title={"Fechar"}
          >
            {"×"}
          </button>
          <img
            src={imagemExpandida}
            alt={"Imagem ampliada do estudo"}
            onClick={(event) => event.stopPropagation()}
            style={{
              maxWidth: "95vw",
              maxHeight: "92vh",
              objectFit: "contain",
              borderRadius: 10,
              boxShadow: "0 16px 48px rgba(0,0,0,0.45)",
            }}
          />
        </div>
      )}
      {showCadastroModal && (
        <Modal
          titulo={"Cadastrar Estudo"}
          onClose={() => setShowCadastroModal(false)}
          maxWidth={640}
        >
          <CadastroEstudo
            activities={activities}
            currentStudent={currentStudent}
            checkpoints={checkpoints}
            setCheckpoints={setCheckpoints}
            showFlash={showFlash}
            goto={() => setShowCadastroModal(false)}
          />
        </Modal>
      )}
    </div>
  );
}
export { Feed };
